import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import { PlusOutlined } from '@ant-design/icons';
import { Col, Table, Row, Divider } from 'antd';
import { Link, Route, Routes, useLocation } from 'react-router-dom';
import DeleteModal from 'components/deleteModalView';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'hooks/useNavigate';
import useVacancyApplicationTypes from '../useVacancyApplicationTypes';
import { useRecoilValue } from 'recoil';
import { getPage } from '../../../../../hooks/useUser';

const MainPage = () => {
  const {
    data,
    columns,
    loading,
    onDelete,
    updateInProcess,
    onChangeTableFilter,
  } = useVacancyApplicationTypes();
  const { t } = useTranslation();
  const pages = useRecoilValue(getPage);
  const { pathname } = useLocation();
  const navigate = useNavigate();

  return (
    <>
      <PageHeader title={t('SETTORE').toUpperCase()}>
        {pages?.ability?.can_create && (
          <Row gutter={16}>
            <Col>
              <Link to={'new'}>
                <Button width={'138px'} big icon={<PlusOutlined />}>
                  {t('NUOVO')}
                </Button>
              </Link>
            </Col>
          </Row>
        )}
      </PageHeader>
      <div className={styles.container}>
        <Divider />
        <Table
          columns={columns}
          dataSource={data.vacancy_application_types}
          pagination={data.pagination}
          loading={loading}
          onChange={onChangeTableFilter}
          scroll={{ x: 1500 }}
          onRow={(record) => ({
            onClick: () => {
              if (record?.id) {
                navigate(`${pathname}/${record.id}`);
              }
            },
            style: { cursor: 'pointer' },
          })}
        />
      </div>
      <Routes>
        <Route
          path={':id/delete'}
          element={
            <DeleteModal loading={updateInProcess} onClickDelete={onDelete} />
          }
        />
      </Routes>
    </>
  );
};

export default MainPage;
